module.exports = __webpack_public_path__ + "img/5f23960.svg";